/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getMakes, getModels } from '../../../api/vehicleApi';
import { getAuthKey, getSessionId, getThirdPartyTypeOfGuest, getUrlKey } from '../../../app/store/combinedSelectors';
import { TypeOfGuest } from '../../../app/store/ThirdPartyClaim/ThirdPartyClaimSlice';
import { getValidVehicleYears } from '../../../utils/Utilities';
import ThirdPartyFNOLContactForm, {
  ThirdPartyFNOLContactFormInfo,
  ThirdPartyFNOLContactInfoFormStyleType,
} from './ThirdPartyFNOLContactForm';

const thirdPartyFNOLInsuredInfoFormStyle: ThirdPartyFNOLContactInfoFormStyleType = {
  pageTitleStyle: {
    fontFamily: 'Open Sans',
    fontWeight: 700,
    fontSize: '24px',
    color: '#007A53',
    lineHeight: '32.68px',
  },
  sectionTitleStyle: {
    fontFamily: 'Open Sans',
    fontWeight: 400,
    fontSize: '24px',
    color: '#232323',
    lineHeight: '32.68px',
  },
  descriptionStyle: {
    fontFamily: 'Open Sans',
    fontWeight: 400,
    fontSize: '16px',
    color: '#232323',
    lineHeight: '21.79px',
  },
  labelTextStyle: {
    fontFamily: 'Open Sans',
    fontWeight: 400,
    fontSize: '16px',
    color: '#232323',
    lineHeight: '21.79px',
    placeHolderColor: '#5B6770',
    bottomMargin: '5px',
  },
  textFieldStyle: {
    fontFamily: 'Open Sans',
    fontWeight: 400,
    fontSize: '16px',
    color: '#25282A',
    lineHeight: '21.79px',
    placeHolderColor: '#5B6770',
    borderColor: '#CCCCCC',
    isPlaceHolderItalic: false,
    height: '64px',
    borderWidth: '2px',
  },
  optionSelectStyle: {
    fontFamily: 'Open Sans',
    fontWeight: 400,
    fontSize: '16px',
    color: '#002855',
    lineHeight: '',
    placeHolderColor: '#5B6770',
    borderColor: '#CCCCCC',
    borderWidth: '2px',
    isPlaceHolderItalic: false,
    height: '64px',
    loadingIndicatorTopMargin: '1.3rem',
  },
  errorLabelStyle: {
    fontFamily: 'Open Sans',
    fontWeight: 400,
    fontSize: '.85rem',
    color: '#a10025',
  },
  checkBoxStyle: {
    fontFamily: '',
    fontWeight: 0,
    fontSize: '16px',
    color: '#25282A',
    checkBoxBorderColor: '#767676',
    checkBoxSelectedColor: '#287ba4',
  },
};

function getValidYearsAsString(): { name: string; value: string }[] {
  const years = getValidVehicleYears();
  const yearsAsCollection: { name: string; value: string }[] = [];
  years.map((year) => yearsAsCollection.push({ name: year.toString(), value: year.toString() }));
  return yearsAsCollection;
}

export default function ThirdPartyFNOLContact(props: any) {
  const [selectedVin, setSelectedVin] = useState<string>('');
  const [selectedYear, setSelectedYear] = useState<string>('');

  const [selectedMake, setSelectedMake] = useState<string>('');

  const [selectedModel, setSelectedModel] = useState<string>('');
  const [modalLoadingOpen, setModalLoadingOpen] = useState(false);

  const [validMakes, setValidMakes] = useState<{ name: string; value: string }[]>([]);
  const [validModels, setValidModels] = useState<{ name: string; value: string }[]>([]);
  const [isValidMakesLoading, setIsValidMakesLoading] = useState(false);
  const [isValidModelsLoading, setIsValidModelsLoading] = useState(false);
  const urlKey = useSelector(getUrlKey);
  const sessionId = useSelector(getSessionId);
  const authKey = useSelector(getAuthKey);
  const typeOfGuest = useSelector(getThirdPartyTypeOfGuest);

  async function vehicleYearSelectionChangeHandler(localSelectedYear: string) {
    if (localSelectedYear !== selectedYear) {
      setSelectedYear(localSelectedYear);
      setIsValidMakesLoading(true);
      setValidMakes([]); // Reset Make selection
      setValidModels([]); // Reset model selection
      const validMakesCollection = await getMakes(urlKey, sessionId, authKey, localSelectedYear);

      setIsValidMakesLoading(false);
      setValidMakes(
        validMakesCollection.map((make: string) => {
          return {
            name: make,
            value: make,
          };
        })
      );
    }
  }

  async function vehicleMakeSelectionChangeHandler(localSelectedMake: string) {
    if (localSelectedMake !== selectedMake) {
      setSelectedMake(localSelectedMake);
      setIsValidModelsLoading(true);
      const validModelsCollection = await getModels(urlKey, sessionId, authKey, selectedYear, localSelectedMake);
      setIsValidModelsLoading(false);
      setValidModels(
        validModelsCollection.map((model: string) => {
          return {
            name: model,
            value: model,
          };
        })
      );
    }
  }

  function consolidatedDataUpdateHandler(info: any) {
    props.sendClaimantInfo(info);
    console.log(info);
  }

  const thirdPartyFNOLVehicleInfo: ThirdPartyFNOLContactFormInfo = {
    styleInfo: thirdPartyFNOLInsuredInfoFormStyle,
    isFilingAsRepresentative: typeOfGuest === TypeOfGuest.INSURANCE_REP,
    validYears: getValidYearsAsString(),
    validMakes: validMakes,
    validModels: validModels,
    isValidMakesLoading: isValidMakesLoading,
    isValidModelsLoading: isValidModelsLoading,
    vehicleYearSelectionChangeHandler: vehicleYearSelectionChangeHandler,
    vehicleMakeSelectionChangeHandler: vehicleMakeSelectionChangeHandler,
    consolidatedDataUpdateHandler: consolidatedDataUpdateHandler,
  };
  return <ThirdPartyFNOLContactForm formInfo={thirdPartyFNOLVehicleInfo} />;
}
